export const apiRoutes = {
  login_admin: '/v1/admin',
  login_standard: '/v1/user/login',
  send_sms_code: '/v1/sendCode/',
  password_update: '/v1/user/passwordUpdate',
  password_change: '/v1/user/passwordChange',
  download_file: '/v1/file',
  get_user_info: '/v1/user/info/',
  get_user_files: '/v1/userFiles/',
  logout: '/v1/user/logout',
};
